<template>
    
    <div>
        <div>
            <!-- <a href="#" class="inline-block"> -->
            <span class="inline-flex items-center px-3 py-0.5 rounded-full text-sm font-medium" :class="articleTypePillClass">
                {{ articleType }}
            </span>
            <!-- </a> -->
        </div>
        <router-link :to="`/articles/${article.url}`" class="block mt-4">
            <p class="text-xl font-semibold text-gray-900">
            {{ article.title }}
            </p>
            <p class="mt-3 text-base text-gray-500">
            {{ article.summary }}
            </p>
        </router-link>
        <div class="mt-6 flex items-center">
            <div class="flex-shrink-0">
            <!-- <a href="#"> -->
                <span class="sr-only">{{ article.author }}</span>
                <img v-if="article.authorPhoto" class="h-10 w-10 rounded-full border border-white shadow-avatar-outline" :src="article.authorPhoto" alt="" />
                <img v-else class="h-10 w-10 rounded-full border border-white shadow-avatar-outline text-blue-600" src="../assets/logo-square-padded.png" alt="" />
            <!-- </a> -->
            </div>
            <div class="ml-3">
            <p class="text-sm font-medium text-gray-900">
                <!-- <a href="#"> -->
                {{ article.author }}
                <!-- </a> -->
            </p>
            <div class="flex space-x-1 text-sm text-gray-500">
                <time :datetime="article.publishDate">
                {{ dayjs(article.publishDate).format('MMM D, YYYY') }}
                </time>
            </div>
            </div>
        </div>
    </div>

</template>
<script>
import dayjs from 'dayjs'

export default {
    props: {
        article: { default: {} }
    },
    data() {
        return {
            dayjs
        }
    },
    computed: {
        articleType() {
            switch (this.article.type) {
                case 'news':
                    return 'News';
                case 'member':
                    return 'Community Article';
                case 'article':
                default:
                    return 'Article'
            }
        },
        articleTypePillClass() {
            switch (this.article.type) {
                case 'news':
                    return 'bg-green-100 text-green-800';
                case 'member':
                    return 'bg-red-100 text-red-800';
                case 'article':
                default:
                    return 'bg-indigo-100 text-indigo-800'
            }
        }
    }
}
</script>